import { render, staticRenderFns } from "./SecondaryMenu.vue?vue&type=template&id=3c425f58&scoped=true"
import script from "./SecondaryMenu.vue?vue&type=script&lang=js"
export * from "./SecondaryMenu.vue?vue&type=script&lang=js"
import style0 from "./SecondaryMenu.vue?vue&type=style&index=0&id=3c425f58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_5d0d328ca533c93cad25b3f77b928576/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c425f58",
  null
  
)

export default component.exports